import { makeAsyncActionCreators } from '../../helpers';
import { AppActionTypes } from '../types';

const initApp = makeAsyncActionCreators(
  AppActionTypes.initApp,
  [],
  [],
  ['error'],
);

export default { initApp };
